module.exports = __webpack_public_path__ + "img/security.45df14d2.jpg";